module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAhCAYAAAC1ONkWAAABDElEQVRYhe2XQWpCMRCGv0ToutviUhel9ADtWvAQvYHQK+iiO/eV3qC36DHalc+d1aUn8O/C5/NRpGQCZZ6QDwJZTMjHZCYkSOpJmknayp+tDi69IGkKvNAtZkHSN3ADrIF3YO8kE4EnoA9saKVxLgnnMT/KxJaxV6baNA7xryhPipiVImaliFkpYlaKmJUiZuUixK7cLE40DkGS6vkO+MD3BTsCrn+LdYqLqLFOEYEuHuU+AktvizNUEVh4W5xhEeqmfAYmHD6+KQTqtk5gR3q5bIA34DVk3hYD0ktgCFTWDXK7cvxPsQ05GYvAJ3CbGP8F3GPs/pyMPZAuBXAHPFo3yRFbYauZql5j4gcGKkEcKESPTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/desktop_icon.png
// module id = 698
// module chunks = 0